
/*饮水思源 初心如磐*/
/*重大活动*/
export const MOSTSOUGHT  =  (process.env.NODE_ENV === 'production')? 40 : 40;//31
/*总书记足迹*/
export const ZHONGSHUJI  =  (process.env.NODE_ENV === 'production')? 41 : 41;//31

/*英烈褒扬进行时*/
/*左侧栏*/
export const LEFTTJ  =    (process.env.NODE_ENV === 'production')? 147 : 147;//33
/*各地*/
export const GDNEWS  =    (process.env.NODE_ENV === 'production')? 39 : 39;//33
/*这些事*/
export const ZHEXIESHI  =    (process.env.NODE_ENV === 'production')? 148 : 148;//33


/*英烈文化短视频展播*/
/*致敬系列视频展播*/
export const ZJXLZB  =    (process.env.NODE_ENV === 'production')? 146 : 146;//33
/*重点陵园展播*/
export const ZDLYZB  =    (process.env.NODE_ENV === 'production')? 117 : 117;//33

/*英雄回家*/
/*英雄回家系列*/
export const YXHJ  =    (process.env.NODE_ENV === 'production')? 149 : 149;//33



export const urlpostfix =   (process.env.NODE_ENV === 'production')? "web-api/":"";
export const jsonpostfix =  (process.env.NODE_ENV === 'production')? "JSON/":"";



// WEBPACK FOOTER //
// ./src/config/global.js